import React from "react";
import { withRouter } from "react-router-dom";

import { Helmet } from "react-helmet";

import { GlobalConsumer } from "../../../../context/GlobalContext";

import Api from "../../../../lib/componentApi";
import customUrlSearchParams from "../../../../lib/customUrlSearchParams";

import Info from "../../../../components/Users/Profile/Info";
import Users from "../";

import Loading from "../../../../components/Common/Loading";
import CommonHeader from "../../../../components/Common/Header";

//Components
import ProfileLinkbar from "./components/ProfileLinkbar";
import ProfileInfobar from "./components/ProfileInforbar";
import ProfileEdit from "./Edit";
import Rewards from "../Rewards";
import Settings from "../Settings";

class ProfileInfo extends React.Component {
  constructor(props, context) {
    super(props, context);
    let {
      addressSection,
      favoritesSection,
      paymentSection,
      promotionsSection,
      editSection,
      ordersSection,
      rewardsSection,
      newsSection,
      settingsSection
    } = this.getEditetSearchParams();
    this.state = {
      addressSection,
      paymentSection,
      favoritesSection,
      promotionsSection,
      editSection,
      ordersSection,
      newsSection,
      settingsSection,
      news: null,
      rewardsSection,
      orderDetail: false,
      errorMessage: null,
      subSection: undefined
    };
  }
  componentDidMount() {
    window.addEventListener("popstate", this.handleRouteChange);
    this.getNews();
  }
  getNews = () => {
    Api.post("/api/user/news", { index: 0, limit: 5 }, (response, errors) => {
      if (errors) {
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else if (response.code) {
        console.log(response, "code-profile-news");
      } else {
        this.setState({ news: response });
      }
    });
  };
  componentWillUnmount() {
    window.removeEventListener("popstate", this.handleRouteChange);
  }
  handleRouteChange = () => {
    const { location, history } = this.props;
    if (location) {
      history.push({
        pathname: location.pathname,
        search: location.search,
        hash: location.hash
      });
    }
  };
  getEditetSearchParams = () => {
    const { location } = this.props;
    const searchParams = new customUrlSearchParams(location.search);
    const allParams = searchParams.getAll();
    const firstParam = Object.keys(allParams)[0];
    let addressSection,
      favoritesSection,
      paymentSection,
      promotionsSection,
      editSection,
      ordersSection,
      newsSection,
      settingsSection,
      rewardsSection;
    if (firstParam) {
      addressSection = firstParam === "addresses";
      favoritesSection = firstParam === "favorites";
      paymentSection = firstParam === "payments";
      promotionsSection = firstParam === "promotions";
      editSection = firstParam === "edit";
      ordersSection = firstParam === "orders";
      rewardsSection = firstParam === "rewards";
      newsSection = firstParam === "news";
      settingsSection = firstParam === "settings";
    }
    return {
      addressSection,
      favoritesSection,
      paymentSection,
      promotionsSection,
      editSection,
      ordersSection,
      rewardsSection,
      newsSection,
      settingsSection
    };
  };
  handleChangeSection = (section, subSection) => {
    if (!this.state[section]) {
      Object.keys(this.state).forEach(key => {
        if (this.state[key] && key !== "news") {
          this.setState({
            [key]: false
          });
        } else {
          this.setState({
            [key]: this.state[key]
          });
        }
      });
      this.setState({ [section]: !this.state[section], subSection }, () => {
        if (this.state.newsSection) {
          Api.get("/api/user/readNews", {}, (response, errors) => {
            if (errors) {
              console.log(errors);
            } else {
              if (response.status) {
                this.getNews();
              }
            }
          });
        }
      });
    } else if (
      section === "rewardsSection" &&
      subSection !== this.state.subSection
    ) {
      Object.keys(this.state).forEach(key => {
        if (this.state[key] && key !== "news") {
          this.setState({
            [key]: false
          });
        } else {
          this.setState({
            [key]: this.state[key]
          });
        }
      });
      this.setState({ [section]: true, subSection });
    } else if (
      section === "settingsSection" &&
      subSection !== this.state.subSection
    ) {
      Object.keys(this.state).forEach(key => {
        if (this.state[key] && key !== "news") {
          this.setState({
            [key]: false
          });
        } else {
          this.setState({
            [key]: this.state[key]
          });
        }
      });
      this.setState({ [section]: true, subSection });
    }
  };
  handleCloseSection = section => {
    this.setState({ [section]: false }, () => {
      this.props.history.push("/profile");
    });
  };
  handleLogout = event => {
    event.preventDefault();
    // eslint-disable-next-line
    if (__isBrowser__) {
      localStorage.removeItem("deliveryDetails");
      Api.get("/api/logout", {}, (response, errors) => {
        if (errors) {
          if (errors === 503) {
            this.setState(() => {
              throw errors;
            });
          } else {
            console.log(errors);
          }
        } else if (response.code) {
          console.log(response, "code-logout");
        } else {
          window.location.href = "/";
        }
      });
    }
  };
  handleChangeSubsection = subSection => {
    if (subSection) {
      this.setState({ subSection });
    }
  };
  renderSelectedSection = (userData, updateUser) => {
    const {
      addressSection,
      paymentSection,
      favoritesSection,
      promotionsSection,
      editSection,
      ordersSection,
      orderDetail,
      rewardsSection,
      subSection,
      newsSection,
      news,
      settingsSection
    } = this.state;
    const unReadNews = (news && news.unReadNews) || 0;
    const refCode = (userData && userData.ref && userData.ref.refCode) || "";
    if (userData) {
      if (addressSection) {
        return (
          <Users.AddressesList
            userData={userData}
            onCloseSection={this.handleCloseSection}
            getProfile={updateUser}
          />
        );
      } else if (editSection) {
        return (
          <ProfileEdit
            user={userData}
            onCloseSection={this.handleCloseSection}
            getProfile={updateUser}
          />
        );
      } else if (paymentSection) {
        return (
          <Users.PaymentMethodsList
            onCloseSection={this.handleCloseSection}
            userData={userData}
            getProfile={updateUser}
          />
        );
      } else if (favoritesSection) {
        return <Users.FavoritesList onCloseSection={this.handleCloseSection} />;
      } else if (newsSection) {
        return (
          <Users.News onCloseSection={this.handleCloseSection} news={news} />
        );
      } else if (ordersSection) {
        return (
          <Users.OrdersList
            onCloseSection={this.handleCloseSection}
            orderDetail={orderDetail}
          />
        );
      } else if (promotionsSection) {
        return (
          <Users.PromotionsList
            onCloseSection={this.handleCloseSection}
            userCode={refCode}
          />
        );
      } else if (rewardsSection) {
        return (
          <Rewards
            changeSubSection={this.handleChangeSubsection}
            subSection={subSection}
          />
        );
      } else if (settingsSection) {
        return (
          <Settings
            subSection={subSection}
            onCloseSection={this.handleCloseSection}
          />
        );
      } else {
        return (
          <Info
            user={userData}
            onClickSection={this.handleChangeSection}
            unReadNews={unReadNews}
          />
        );
      }
    } else {
      return <Loading />;
    }
  };
  render() {
    const { userData } = this.props;
    const {
      editSection,
      paymentSection,
      addressSection,
      favoritesSection,
      promotionsSection,
      ordersSection,
      rewardsSection,
      subSection,
      newsSection,
      news,
      settingsSection
    } = this.state;
    let unReadNews = (news && news.unReadNews) || 0;
    return (
      <>
        <Helmet>
          <title>Profile</title>
          <meta property="og:title" content="Profile" />
        </Helmet>
        <div className="visible-xs">
          <CommonHeader active="profile" />
        </div>

        <div className="container">
          <div className="row">
            <div className="col-sm-3">
              <div className="hide-xs">
                <div className="sidebar left-sidebar">
                  {(userData && userData.uid && (
                    <ProfileInfobar userData={userData} />
                  )) || <noscript />}
                  {/* .profile-bar */}
                  <ProfileLinkbar
                    handleChangeSection={this.handleChangeSection}
                    handleLogout={this.handleLogout}
                    editSection={editSection}
                    paymentSection={paymentSection}
                    addressSection={addressSection}
                    ordersSection={ordersSection}
                    favoritesSection={favoritesSection}
                    promotionsSection={promotionsSection}
                    rewardsSection={rewardsSection}
                    subSection={subSection}
                    newsSection={newsSection}
                    unReadNews={unReadNews}
                    settingsSection={settingsSection}
                  />
                </div>
                {/* .sidebar */}
              </div>
              {/* .hide-xs */}
            </div>
            {/* .col-sm-3 */}
            <GlobalConsumer>
              {({ user, updateUser }) => (
                <div className="col-sm-9">
                  {this.renderSelectedSection(user, updateUser)}
                </div>
              )}
            </GlobalConsumer>
            {/* .col-sm-9 */}
          </div>
          {/* .row */}
        </div>
        {/* .container */}
      </>
    );
  }
}

export default withRouter(ProfileInfo);
